import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {message} from 'antd';
import actions from './actions';
import {get, post} from 'bukku/shared/ApiService';

// Read
export function* readRequest() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_REQUEST, function* ({ id, cs, ct, dateTo }) {
        try {
            const response = yield call(get, `/public/statements/${id}`, {
                cs,
                ct,
                date_to: dateTo,
            });
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_SUCCESS,
                company: data.company,
                statement: data.statement,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_ERROR,
                error,
            });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_ERROR, function* ({ error }) {
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403)
            yield message.error(error.message);
    });
}

// Read
export function* readV2Request() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_V2_REQUEST, function* ({
        statementId, hash, id, subdomain, dateFrom, dateTo,
    }) {
        try {
            const url = hash ?
                `/v2/public/statements/${statementId}/${hash}` :
                `/v2/public/statements/${id}/${dateFrom}/${dateTo}`;
            const response = yield call(get, url, {
                cs: subdomain,
                ct: 'abcdefgi',
            });
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_V2_SUCCESS,
                company: data.company,
                statement: data.statement,
                payment_url: data.payment_url,
                ct: data.ct,
                cs: data.cs,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_V2_ERROR,
                error,
            });
        }
    });
}
export function* readV2Success() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_V2_SUCCESS, () => {});
}
export function* readV2Error() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_V2_ERROR, function* ({ error }) {
        yield console.log('aaa readError', { error });
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403)
            yield message.error(error.message);
    });
}

// Read Statement Payment
export function* readStatementPaymentRequest() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_REQUEST, function* ({request}) {
        try {
            console.log('readStatementPaymentRequest request', request);
            const response = yield call(get, '/payex/contact_payments/create', request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_SUCCESS,
                payment_url: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_ERROR,
                error,
            });
        }
    });
}
export function* readStatementPaymentSuccess() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_SUCCESS, () => {});
}
export function* readStatementPaymentError() {
    yield takeEvery(actions.PUBLIC_STATEMENT_READ_STATEMENT_PAYMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* createPayexPaymentRequest() {
    yield takeEvery(actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_REQUEST,
        function* (request, context) {
            try {
                const response = yield call(
                    post, '/payex/statement_payments', request.request, context,
                );

                if (request.openInNewTab)
                    yield window.open(`${response.data.url}`, "_blank");
                else
                    yield window.open(`${response.data.url}`, "_self");

                //OK
                yield put({
                    type: actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_SUCCESS,
                });
            }
            catch (error) {
                yield put({
                    type: actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_ERROR,
                    error,
                });
            }
        });
}

export function* createPayexPaymentSuccess() {
    yield takeEvery(actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_SUCCESS, () => {});
}

export function* createPayexPaymentError() {
    yield takeEvery(actions.PUBLIC_STATEMENT_CREATE_PAYEX_PAYMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(readV2Request),
        fork(readV2Success),
        fork(readV2Error),
        fork(readStatementPaymentRequest),
        fork(readStatementPaymentSuccess),
        fork(readStatementPaymentError),
        fork(createPayexPaymentRequest),
        fork(createPayexPaymentSuccess),
        fork(createPayexPaymentError),
    ]);
}
